enum RegistrationPersonalActionType {
    REGISTRATION_PERSONAL_SELECT_PIVOT = "REGISTRATION_PERSONAL_SELECT_PIVOT",
}

export default RegistrationPersonalActionType;